export const SUPPORTED_COUNTRY_CODES = [
  'AU',
  'AX',
  'BN',
  'HK',
  'ID',
  'IN',
  'JP',
  'KH',
  'KR',
  'LA',
  'MY',
  'NZ',
  'PH',
  'SG',
  'TH',
  'TW',
  'VN',
  'AD',
  'AT',
  'AZ',
  'BH',
  'BE',
  'BG',
  'CY',
  'CZ',
  'DK',
  'EG',
  'FI',
  'FR',
  'DE',
  'GR',
  'HU',
  'IE',
  'IT',
  'JO',
  'KZ',
  'KW',
  'LB',
  'LU',
  'MT',
  'MA',
  'NL',
  'NO',
  'OM',
  'PL',
  'PT',
  'QA',
  'RO',
  'RU',
  'SA',
  'RS',
  'SK',
  'ZA',
  'ES',
  'SE',
  'CH',
  'TN',
  'TR',
  'AE',
  'GB',
  'CA',
  'AW',
  'BS',
  'BB',
  'BO',
  'BR',
  'KY',
  'CL',
  'CO',
  'CR',
  'CW',
  'DO',
  'EC',
  'SV',
  'GT',
  'GY',
  'HN',
  'JM',
  'MX',
  'PA',
  'PY',
  'PE',
  'PR',
  'TT',
  'TC',
  'UY',
  'US',
];
export const CUSTOM_COUNTRY_LABELS = {
  AX: 'Asia Pacific Support Center',
  BO: 'Bolivia',
  BN: 'Brunei',
  CZ: 'Czech Republic',
  LA: 'Laos',
  KR: 'South Korea',
  TW: 'Taiwan',
  TT: 'Trinidad & Tobago',
  TC: 'Turks & Caicos',
  VN: 'Vietnam',
};
export const DEFAULT_COUNTRY_CODE = 'AX';
